import { writable } from 'svelte/store'
import { router } from '@inertiajs/svelte'

// Shared between the menu item and the 18+ dialog, which CANNOT live in the
// same subtree: the dialog is opened by selecting a menu item, and that
// selection closes the menu — a dialog rendered inside DropdownMenu.Content is
// destroyed before it can ever be seen. So the item lives in the menu, the
// dialog is rendered once at the top-bar root, and this store connects them.
export const ageDialogOpen = writable(false)

export function applySensitive(show) {
  // Close explicitly. The dialog lives in Top.svelte, which is in the
  // persistent layout, so an Inertia visit swaps the page component and leaves
  // this store untouched — the dialog would sit open over the reloaded feed
  // and read as "the button did nothing", even though the request succeeded.
  ageDialogOpen.set(false)
  router.patch('/preferences/sensitive', { show }, { preserveScroll: true })
}

// Turning it off never prompts; neither does turning it back on once the
// attestation has been given (the cookie stores "0" rather than being
// deleted, so `confirmed` stays true).
export function requestSensitiveToggle(showSensitive, confirmed) {
  if (showSensitive) return applySensitive(false)
  if (confirmed) return applySensitive(true)
  ageDialogOpen.set(true)
}
